var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-06-16
 * @brief EHP 진단평가결과(카드) 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from 'react';
import ECharts from 'echarts-for-react';
//
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { checkStep, doneAssessmentState, itemState, tempCheckValue, } from '../../../recoil/assessmentState';
//utils
import clog from "../../../utils/logUtils";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 진단평가결과(카드) 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function EhcCheckResult(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const curItem = useRecoilValue(itemState);
    const setRecoilCurItem = useSetRecoilState(itemState);
    const resetRecoilTsItemCheckListInfo = useResetRecoilState(doneAssessmentState);
    const setCurCheckStep = useSetRecoilState(checkStep);
    const resetCurCheckStep = useResetRecoilState(checkStep);
    const setRecoilTempCheckVal = useSetRecoilState(tempCheckValue);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    //props
    const { company, zone, subZone, room, spg } = props.curTreeData;
    const setStatusReload = props.setStatusReload;
    //
    const [checkResult, setCheckResult] = useState(null);
    const [reloadOn, setRloadOn] = useState(false); // 재진행 팝업
    const [requestOn, setRequestOn] = useState(false); // 점검요청 팝업
    const [shareOn, setShareOn] = useState(false); // 공유 팝업
    const [link, setLink] = useState("");
    const [request, setRequst] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientWidth <= 430)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientWidth <= 430)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
    });
    //점검결과 API
    clog("IN EHCCHEKRESULT : INIT : " + curItem.ehcType);
    clog("IN EHCCHEKRESULT : INIT : " + curItem.assessment.assessmentId);
    const { data: data, isLoading } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: `/api/v2/assessment/${curItem.assessment.assessmentId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data) {
            clog("IN EHCRESULT : RETURN : " + JSON.stringify(curItem.ehcType));
            if (data.codeNum == 200) {
                clog("IN EHCRESULT : RETURN : " + JSON.stringify(data.body));
                setCheckResult(data.body);
            }
            else { // api if
            }
        }
    }, [data]);
    // result 재진행 팝업창 열기
    function rerunPopOpen(e) {
        setRloadOn(true);
    }
    // premium 팝업창 열기
    function onClickPremiumOpen(e) {
        setRequestOn(true);
    }
    function onSharePop(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/report`,
                "appQuery": {
                    assessmentId: curItem.assessment.assessmentId
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const fileLink = `${window.location.origin}${CONST.URL_COMM_PDFVIEWER}?${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFNM}=${curItem.serialNo}_진단점검리포트.PDF&${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFID}=${data.body.fileLink}`;
                    setShareOn(true);
                    setLink(fileLink);
                }
                else {
                    alert("리포트 생성 중입니다. 잠시 후 다시 진행 해주세요.");
                }
            }
        });
    }
    //ROLE_ADMIN
    function itemCheckAccepted(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/product/company/zone/subzone/room/panel/item/itemstatus/ACCEPTED",
                appQuery: {
                    itemId: item.itemId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    // clog("IN PREMIUM : itemCheckAccepted : " + JSON.stringify(data.body));
                    alert("Advanced 점검요청이 완료 되었습니다.");
                    setRequst(data.data.msg);
                    setStatusReload(true);
                    //setSavedFiles(data.body);
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    // ECahrt , data 반시계 반향으로 적용
    const totalScore = (checkResult == null) ? -1 : (checkResult.hasOwnProperty("totalScore")) ? checkResult.totalScore : -1; // totalAPI
    const alarmDto = (checkResult == null) ? null : (checkResult.hasOwnProperty("alarmDto")) ? checkResult.alarmDto : null; // AlarmAPI
    const checkGroupValue = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkGroupValueDtoList")) ? checkResult.checkGroupValueDtoList : null;
    const checkAvgValue = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkAvgValueDtoList")) ? checkResult.checkAvgValueDtoList : null;
    const checkValueList = (checkResult == null) ? null : (checkResult.hasOwnProperty("checkValueDtoMap")) ? checkResult.checkValueDtoMap : null;
    const option = {
        color: [
            "rgba(144, 159, 183, 0.5)",
            "#FF6781",
            "#5B71EF", // VCB 평균 점수 Data
            // "#FF917C"
        ],
        // 차트 하단 정보
        legend: {
            bottom: "12",
            // right: "10",
            // width: "100",
            // itemGap: 9,
            itemWidth: 14,
            itemHeight: 9,
            align: "auto",
            /*  data: [
               {
                 //  icon: "image://./static/* 개발 서버 /asset/ 배포용
                 icon: "image://./asset/img/icon_legend_gray.png",
                 name: "배점",
                 textStyle: {
                   fontFamily: "Noto Sans KR",
                   fontWeight: 400,
                   fontSize: 11,
                   color: "#2A2C2F",
                   padding: [0, 0, 0, 4],
                 },
               },
               {
                 icon: "image://./asset/img/icon_legend_red.png",
                 name: "평가점수",
                 textStyle: {
                   fontFamily: "Noto Sans KR",
                   fontWeight: 400,
                   fontSize: 11,
                   color: "#2A2C2F",
                   padding: [0, 0, 0, 4],
                 },
               },
               {
                 icon: "image://./asset/img/icon_legend_purple.png",
                 //name: "VCB 평균점수",
                 name: `${spg.spgName} 평균점수`,
                 textStyle: {
                   fontFamily: "Noto Sans KR",
                   fontWeight: 400,
                   fontSize: 11,
                   color: "#2A2C2F",
                   padding: [0, 0, 0, 4],
                 },
               },
             ], */
        },
        // 점수 나오게하는 곳 
        tooltip: {
            position: ['50%', '50%']
        },
        radar: [
            {
                indicator: [
                    // status 정보에 따라 변함...
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 1) || !checkGroupValue[0].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[0].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 2) || !checkGroupValue[1].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[1].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 3) || !checkGroupValue[2].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[2].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 4) || !checkGroupValue[3].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[3].checkGroupName, color: "black" },
                    { text: (checkGroupValue == null) ? "" : ((checkGroupValue.length < 5) || !checkGroupValue[4].hasOwnProperty("checkGroupName")) ? "" : checkGroupValue[4].checkGroupName, color: "black" },
                ],
                // 배경 간격
                splitNumber: 1,
                // 차트 max  
                radius: 100,
                // startAngle: 90,
                //radar 사이 box style
                splitArea: {
                    areaStyle: {
                        color: ["#FFF", "#FFF"],
                    },
                },
                // 구분선 색상
                axisLine: {
                    lineStyle: {
                        // color: '#2A2C2F'
                        color: "#C3CBD8",
                    },
                },
                // 배경 라인 색상
                splitLine: {
                    lineStyle: {
                        color: "#C3CBD8",
                    },
                },
                // 배경 font
                axisName: {
                    fontWeight: 500,
                    fontFamily: "Noto Sans KR",
                    fontSize: (isMobile) ? 12 : 16
                }
            },
        ],
        series: [
            {
                type: "radar",
                emphasis: {
                    lineStyle: {
                        width: 4,
                    },
                },
                data: [
                    {
                        value: [20, 20, 20, 20, 20],
                        name: "배점",
                        symbol: "circle",
                        symbolSize: 6,
                    },
                    {
                        value: [
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 1) || !checkGroupValue[0].hasOwnProperty("value")) ? -1 : checkGroupValue[0].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 2) || !checkGroupValue[1].hasOwnProperty("value")) ? -1 : checkGroupValue[1].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 3) || !checkGroupValue[2].hasOwnProperty("value")) ? -1 : checkGroupValue[2].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 4) || !checkGroupValue[3].hasOwnProperty("value")) ? -1 : checkGroupValue[3].value,
                            (checkGroupValue == null) ? -1 : ((checkGroupValue.length < 5) || !checkGroupValue[4].hasOwnProperty("value")) ? -1 : checkGroupValue[4].value,
                        ],
                        name: "평가점수",
                        symbol: "circle",
                        symbolSize: 6,
                        //내부 style
                        areaStyle: {
                            // 투명도
                            opacity: 0.1
                        },
                    },
                    {
                        value: [
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 1) || !checkAvgValue[0].hasOwnProperty("value")) ? -1 : checkAvgValue[0].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 2) || !checkAvgValue[1].hasOwnProperty("value")) ? -1 : checkAvgValue[1].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 3) || !checkAvgValue[2].hasOwnProperty("value")) ? -1 : checkAvgValue[2].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 4) || !checkAvgValue[3].hasOwnProperty("value")) ? -1 : checkAvgValue[3].value,
                            (checkAvgValue == null) ? -1 : ((checkAvgValue.length < 5) || !checkAvgValue[4].hasOwnProperty("value")) ? -1 : checkAvgValue[4].value,
                        ],
                        //name: "VCB 평균점수",
                        name: `${spg.spgName} 평균점수`,
                        symbol: "circle",
                        symbolSize: 6,
                        //내부 style
                        areaStyle: {
                            // 투명도
                            opacity: 0.1
                        },
                    },
                ],
            },
        ],
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ehc__detail ehc__result", ref: mobileRef },
            React.createElement("div", { className: "result__txt" },
                React.createElement("p", { className: 
                    /*(alarmDto.alarmStatus == "SAFETY") ? "tit " : "tit caution"*/
                    `tit ${(alarmDto != null) ? (alarmDto.alarmStatus == "SAFETY") ? "" : "caution" : "caution"}` },
                    React.createElement("span", null, "\uC885\uD569\uC810\uC218")),
                React.createElement("p", { className: "score" }, totalScore),
                React.createElement("p", { className: "txt" }, (alarmDto != null) ? alarmDto.description : "-------------------------------------------X")),
            React.createElement("div", { className: "scrollH" },
                React.createElement("div", null,
                    React.createElement("div", { className: "chart", style: { "width": "100%", "margin": "0 auto" } },
                        React.createElement("div", { id: "radar", style: { "height": "300px" } },
                            React.createElement(ECharts, { option: option, className: "bottom  h300" })))),
                ((checkGroupValue != null) && (checkValueList != null)) && checkGroupValue.filter(group => checkValueList.hasOwnProperty(group.checkGroupName)).map((name, idx) => (React.createElement("div", { className: "ma__score", key: idx },
                    React.createElement("p", { className: "tit" }, name.checkGroupName),
                    React.createElement("ul", { className: "score__info" }, ((checkValueList != null) && (checkValueList.hasOwnProperty(name.checkGroupName))) && checkValueList[name.checkGroupName].map((list) => (React.createElement("li", { key: list.checkItemId, className: (list.isChecked) ? "disabled" : "" },
                        React.createElement("p", { className: "tit" },
                            React.createElement("span", null, list.checkItemName)),
                        React.createElement("ul", { className: (list.isChecked) ? "icon-score" : "icon-score score" + ((list.value == 0) ? 1 : (list.value == 1) ? 2 : (list.value == 2) ? 3 : (list.value == 3) ? 4 : (list.value == 4) ? 5 : "") },
                            React.createElement("li", null, "Bad"),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "\uB9E4\uC6B0\uB098\uC068")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "\uB098\uC068")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "\uBCF4\uD1B5")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "\uC88B\uC74C")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "\uB9E4\uC6B0\uC88B\uC74C")),
                            React.createElement("li", null, "Good"))))))))))),
        React.createElement("div", { className: "tbl__bottom" },
            React.createElement("ul", { className: "btn__wrap" },
                React.createElement("li", null,
                    React.createElement("button", { type: "button", className: "btn-reload", "data-popup": "btn-reload", onClick: (e) => rerunPopOpen(e) },
                        React.createElement("span", null, "\uC7AC\uC9C4\uD589")),
                    React.createElement("button", { type: "button", className: "btn-share", onClick: (e) => onSharePop(e) },
                        React.createElement("span", null, "\uC9C4\uB2E8\uACB0\uACFC \uACF5\uC720"))),
                (curItem.ehcType !== "ADVANCED") &&
                    React.createElement("li", null, (alarmDto != null) && (alarmDto.alarmStatus != "SAFETY") && (request.length <= 0) &&
                        React.createElement("button", { type: "button", className: `btn-checkpop ${(curItem.ehcType == "BASIC") ? "bg-green" : (curItem.ehcType == "PREMIUM") ? "bg-yellow" : ""}`, "data-pop": "pop-check", onClick: (e) => (curItem.ehcType == "BASIC") ? onClickPremiumOpen(e) : itemCheckAccepted(curItem) },
                            React.createElement("span", null,
                                (curItem.ehcType == "BASIC") ? "Premium" : "Advanced",
                                "  \uC810\uAC80 \uC694\uCCAD"))))),
        React.createElement(ReloadPop, { curTreeData: props.curTreeData, curItem: curItem, setStatusReload: setStatusReload, reloadOn: reloadOn, setRloadOn: setRloadOn }),
        React.createElement(RequestPop, { curItem: curItem, requestOn: requestOn, setRequestOn: setRequestOn, setRequst: setRequst, setStatusReload: setStatusReload }),
        React.createElement(SharePop, { shareOn: shareOn, setShareOn: setShareOn, link: link }),
        (alarmDto) && (alarmDto.alarmStatus == "SAFETY") &&
            React.createElement(NormarPop, { alarmDto: alarmDto })));
}
export default EhcCheckResult;
function ReloadPop(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilCurItem = useSetRecoilState(itemState);
    const resetRecoilTsItemCheckListInfo = useResetRecoilState(doneAssessmentState);
    const setCurCheckStep = useSetRecoilState(checkStep);
    const resetCurCheckStep = useResetRecoilState(checkStep);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    //props
    const { company, zone, subZone, room, spg } = props.curTreeData;
    const curItem = props.curItem;
    const setStatusReload = props.setStatusReload;
    const setRloadOn = props.setRloadOn;
    const reloadOn = props.reloadOn;
    // DELETE API
    function deleteResult(assessmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN EHCCHEKRESULT : deleteResult : " + assessmentId);
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/assessment/values",
                "appQuery": {
                    assessmentId: assessmentId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                clog("IN EHCRESULT : deleteResult : " + JSON.stringify(curItem));
                setStatusReload(true);
                setCurCheckStep(0);
                if (data.codeNum == 200) {
                    clog("IN EHCRESULT : deleteResult : " + JSON.stringify(data.body));
                }
                else { // api if
                }
            }
        });
    }
    // 확인 버튼 
    function hadleRerun(item) {
        // 선택된 ITEM의 assessmentID 초기화 필요    
        deleteResult(item.assessment.assessmentId);
        resetRecoilTsItemCheckListInfo();
        //setCurCheckStep(0);
        resetCurCheckStep();
        const tmpCurItem = {
            spgTree: {
                company: company,
                zone: zone,
                subZone: subZone,
                room: room,
                spg: spg
            },
            ehcType: item.ehcType,
            itemId: item.itemId,
            itemName: item.itemName,
            serialNo: item.serialNo,
            itemStatus: item.itemStatus,
            itemStep: item.itemStep,
            responsible: item.responsible,
            assessment: {
                preAssessmentId: item.assessment.preAssessmentId,
                assessmentId: null,
                totalComment: null,
                reportId: null,
                updatedTime: null,
                isTempSave: null
            }
        };
        var inputData = {
            item: item,
            checkVal: {
                assessmentId: null,
                checkItemId: -1,
                checkItemName: "",
                isChecked: false,
                value: "",
                valueType: "",
                comment: "",
                versionNo: ""
            },
            stepDone: false
        };
        setRecoilCurItem(tmpCurItem);
        resetRecoilTempCheckVal();
    }
    // result 재진행 팝업창 닫기
    function rerunPopClose(e) {
        setRloadOn(false);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-reload", className: `popup-boxin ${(reloadOn) ? "on" : ""}` },
            React.createElement("div", { className: "page-detail w400" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null,
                        (curItem.ehcType == "BASIC") ? "Basic" : (curItem.ehcType == "PREMIUM") ? "Premium" : "Advanced",
                        " \uC7AC\uC9C4\uD589"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => rerunPopClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("p", { className: "fontMedium" },
                        (curItem.ehcType == "BASIC") ? "Basic" : (curItem.ehcType == "PREMIUM") ? "Premium" : "Advanced",
                        " \uC810\uAC80\uC744 \uC7AC\uC9C4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"),
                    React.createElement("p", null, "\uC774\uC804 \uC810\uAC80 \uB0B4\uC6A9\uC740 \uC0AC\uB77C\uC9C0\uAC8C \uB429\uB2C8\uB2E4.")),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => rerunPopClose(e) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => hadleRerun(curItem) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
function RequestPop(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curItem = props.curItem;
    const requestOn = props.requestOn;
    const setRequestOn = props.setRequestOn;
    const setRequst = props.setRequst;
    const setStatusReload = props.setStatusReload;
    // premium 팝업창 닫기
    function onClickPremiumColse(e) {
        setRequestOn(false);
    }
    //ROLE_USER
    function itemCheckRequested(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/product/company/zone/subzone/room/panel/item/itemstatus/REQUESTED",
                appQuery: {
                    itemId: item.itemId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN PREMIUM : itemCheckRequested : " + JSON.stringify(data.body));
                    alert("정밀진단 요청이 완료 되었습니다.");
                    setRequestOn(false);
                    setRequst(data.data.msg);
                    setStatusReload(true);
                    //setSavedFiles(data.body);
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-check", className: `popup-boxin ${(requestOn) ? "on" : ""}` },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null,
                        (curItem.ehcType == "BASIC") ? "Premium" : (curItem.ehcType == "PREMIUM") ? "Advanced" : null,
                        " \uC815\uBC00\uC9C4\uB2E8 \uC694\uCCAD"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => onClickPremiumColse(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("p", { className: "fontMedium" }, "LS ELECTRIC \uC804\uBB38\uAC00\uAC00 \uD65C\uC120/\uC815\uC804 \uC0C1\uD0DC\uC5D0\uC11C \uC804\uB825\uC124\uBE44\uC758 \uC804\uAE30\uC801 \uAE30\uACC4\uC801 \uC131\uB2A5 \uC810\uAC80 \uBC0F \uC2DC\uD5D8\uC744 \uC9C4\uD589\uD558\uACE0 \uC124\uBE44\uC758 \uC815\uD655\uD55C \uC0C1\uD0DC\uB97C \uC81C\uACF5\uD569\uB2C8\uB2E4."),
                    React.createElement("p", null, "(\uCD9C\uC7A5 \uBC0F \uD604\uC7A5 \uC815\uBC00 \uC9C4\uB2E8 \uC11C\uBE44\uC2A4 \uBE44\uC6A9 \uBC1C\uC0DD)")),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickPremiumColse(e) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => itemCheckRequested(curItem) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
function SharePop(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const shareOn = props.shareOn;
    const setShareOn = props.setShareOn;
    const reportId = props.reportId;
    const item = props.item;
    const link = props.link;
    //
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    function shareClose(e) {
        if (shareOn === true) {
            setShareOn(false);
        }
        setToMails("");
    }
    function handleSetUserId(e) {
        setErrorList(errorList.filter((err) => (err.field !== "toMails")));
        setToMails(e.target.value);
    }
    // fileLInk API
    function linkShare(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/report/email`,
                "appQuery": {
                    toMails: [toMails],
                    fileLink: link,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("메일 전송이 완료되었습니다.");
                    setShareOn(false);
                    setToMails("");
                }
                else {
                    if (toMails == "") {
                        setErrorList([{ field: "toMails", msg: "필수 항목입니다." }]);
                    }
                    else {
                        setErrorList(data.body.errorList);
                    }
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-share", className: `popup-boxin ${(shareOn) ? "on" : ""}` },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "\uC9C4\uB2E8\uACB0\uACFC \uACF5\uC720"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => shareClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("ul", { className: "form__input w85p" },
                        React.createElement("li", { className: "center" },
                            React.createElement("p", { className: "tit" }, "E-Mail"),
                            React.createElement("div", { className: "input__area w260" },
                                React.createElement("input", { type: "text", id: "userId0", placeholder: "\uACF5\uC720\uD558\uC2E4 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "toMails")).length > 0) ? "input-error" : "", value: toMails, onChange: (e) => handleSetUserId(e) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "toMails")).map((err) => err.msg)))))),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => shareClose(e) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => linkShare(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
function NormarPop(props) {
    const alarmDto = props.alarmDto;
    function NomralPopClose(e) {
        const targetElement = e.target;
        const popupBox = targetElement.closest(".popup-boxin");
        // if (CUTIL.isnull(filterBox)) return;
        //  clog(flieterLayer);
        // clog("filterOpen : " + filterBox.className);
        if (popupBox.classList.contains("on")) {
            popupBox.classList.remove("on"); // open
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-check", className: `popup-boxin ${(alarmDto.alarmStatus == "SAFETY") && "on"}` },
            React.createElement("div", { className: "page-detail w400" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "\uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC"),
                    React.createElement("button", { className: "btn btn-close ", onClick: (e) => NomralPopClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("p", { className: "fontMedium" }, "\uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC \uAE30\uC900 \uC810\uC218 \uC774\uC0C1\uC73C\uB85C \uC815\uC0C1(NORMAL) \uB2E8\uACC4\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.")),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "close js-close", onClick: (e) => NomralPopClose(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
/* function UpdataPop(props){
  
  // by 20220819 hjo
   const [resultPutPop, setResultPutPop] = useState(false);
  const [comment, setComment] = useState<string>("");
  const [saveComment, setSaveComment] = useState<string>("");
  // by hjo 20220819
   function onClickComment(e) {
    e.preventDefault();
    if (resultPutPop === false) {
      setResultPutPop(true);
    }
  }
 
  function close(e) {
    if (resultPutPop === true) {
      setResultPutPop(false);
    }
  }
  async function onClickSaveComment(e) {
    onClickComment(e); // for layer close
    let data: any = null;
    data = await HttpUtil.PromiseHttp({
      "httpMethod": "PUT",
      "appPath": `/api/v2/assessment/alarmmsg`,
      "appQuery": {
        "assessmentId": assessmentId,
        "alarmMessage": comment
      },
      userToken: userInfo.loginInfo.token,
    });
    if (data) {
      if (data.codeNum == 200) {
        setSaveComment(data.body.alarmMessage);
        close(e)
      }
    }
  }
  return(
    <>
       <div id="pop-edit" className={`pop-edit popup-boxin ${(resultPutPop) ? "on" : ""}`} >
            <div className="page-detail">
              <div className="popup__head">
                <h1>Edit Message</h1>
                <button className="btn btn-close" onClick={(e) => close(e)}><span className="hide">닫기</span></button>
              </div>
              <div className="popup__body">
                <p className="txtnum">{comment.length} / 120</p>
                <textarea id="text" placeholder="의견을 입력하세요." value={comment}
                  onKeyPress={(e) => CUTIL.beforeHandleComment(e, 120)}
                  onKeyUp={(e) => CUTIL.afterHandleComment(e, 120, setComment)}
                  onChange={(e) => setComment(e.target.value)}
                ></textarea>
              </div>
               <!--220610, memo__txt 태그 의견확인일 경우 노출-->
               <!-- <p className="memo__txt">현충일(顯忠日)은 나라를 위해 희생한 순국선열(殉國先烈)과 전몰(戰歿)한 장병들의 충렬을 기리고 얼을 위로하기 위하여 지정된 대한민국의 중요한 기념일이다.중요한 기념일이다.이다.얼을 위로하기 위하여 지정된 대한민국의 중요한 기념일이다.중요한 기념일이다.</p> -->
              <div className="popup__footer">
                <button type="button" onClick={(e) => onClickSaveComment(e)}><span>저장</span></button>
                 <!--220610, 삭제, 수정버튼 의견확인일 경우 노출-->
                <!-- <button type="button" class="bg-gray"><span>삭제</span></button>
                 <button type="button"><span>수정</span></button>
              </div>
            </div>
          </div>
    </>
  );
} */ 
